import { createContext, useContext, useState } from 'react';

type WxCopilotContextType = {
  isPanelOpen: boolean;
  setIsPanelOpen: (isPanelOpen: boolean) => void;
  isCopilotRendered: boolean;
  setIsCopilotRendered: (isCopilotRendered: boolean) => void;
};

const WxCopilotContext = createContext<WxCopilotContextType | undefined>(
  undefined,
);

export function WxCopilotProvider({ children }: { children: React.ReactNode }) {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [isCopilotRendered, setIsCopilotRendered] = useState(false);

  return (
    <WxCopilotContext.Provider
      value={{
        isPanelOpen,
        setIsPanelOpen,
        isCopilotRendered,
        setIsCopilotRendered,
      }}
    >
      {children}
    </WxCopilotContext.Provider>
  );
}

export function useWxCopilotContext() {
  const context = useContext(WxCopilotContext);
  if (!context) {
    throw new Error('useWxCopilot must be used within a WxCopilotProvider');
  }
  return context;
}
